export const PRODUCT_IMAGE_CROP_SIZE = 570;
export const PRODUCT_IMAGE_MAX_WIDTH = 1020;
export const PRODUCT_IMAGE_COMPRESSION_QUALITY = 0.8;
export const PRODUCT_IMAGE_ASPECT_RATIO = 3 / 2;
